import React, { useState, useEffect } from 'react';
import PageHeader from '../components/PageHeader';

const productsData = [
  ...Array.from({ length: 5 }, (_, i) => ({ name: `Componente Telaio A-${i + 1}`, category: 'Elementi Autotelaio', image: `https://picsum.photos/seed/telaio${i}/400/300` })),
  ...Array.from({ length: 5 }, (_, i) => ({ name: `Supporto Sensore B-${i + 1}`, category: 'Supporti Elettronici', image: `https://picsum.photos/seed/sensore${i}/400/300` })),
  ...Array.from({ length: 5 }, (_, i) => ({ name: `Connettore Cavo C-${i + 1}`, category: 'Cablaggi', image: `https://picsum.photos/seed/cavo${i}/400/300` })),
  ...Array.from({ length: 5 }, (_, i) => ({ name: `Gancio Fissaggio D-${i + 1}`, category: 'Sistemi di Fissaggio', image: `https://picsum.photos/seed/gancio${i}/400/300` })),
];

const categories = ['Tutti', ...Array.from(new Set(productsData.map(p => p.category)))];

const Prodotti: React.FC = () => {
  useEffect(() => {
    document.title = 'CO.ME.ST. S.R.L - Prodotti';
  }, []);

  const [selectedCategory, setSelectedCategory] = useState('Tutti');

  const filteredProducts = selectedCategory === 'Tutti'
    ? productsData
    : productsData.filter(p => p.category === selectedCategory);

  return (
    <div className="bg-white">
      <PageHeader title="I Nostri Prodotti" breadcrumb="Prodotti" />
      <div className="container px-4 py-12 mx-auto">
        <div className="mb-12 text-center">
          <p className="text-gray-600">Esplora la nostra vasta gamma di componenti di alta qualità per il settore automotive.</p>
        </div>
        <div className="flex flex-wrap gap-4 justify-center mb-12">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-medium transition-colors duration-200 ${
                selectedCategory === category
                  ? 'bg-red-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {filteredProducts.map((product, index) => (
            <div key={index} className="overflow-hidden rounded-lg border shadow-md transition-shadow duration-300 hover:shadow-xl">
              <img src={product.image} alt={product.name} className="object-cover w-full h-48"/>
              <div className="p-6 text-center">
                <h3 className="mb-2 font-bold text-gray-800">{product.name}</h3>
                <p className="text-sm text-red-600">{product.category}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Prodotti; 